import { useState, useCallback } from "react";
import { useOverlayState } from "./useOverlayState";

const ACCESSIBLE_MODE_KEY = "wondermaps-accessible-mode";

export function useAccessibleMode() {
  const overlayState = useOverlayState();
  const overlayAccessible = overlayState.isOverlayActive("wheelchair")
    || overlayState.isOverlayActive("mobility")
    || overlayState.isOverlayActive("family");

  const [manualAccessibleMode, setManualAccessibleMode] = useState(
    () => typeof window !== "undefined" && localStorage.getItem(ACCESSIBLE_MODE_KEY) === "true"
  );

  const accessibleMode = overlayAccessible || manualAccessibleMode;

  const toggleManualAccessible = useCallback(() => {
    setManualAccessibleMode(prev => {
      const next = !prev;
      if (next) localStorage.setItem(ACCESSIBLE_MODE_KEY, "true");
      else localStorage.removeItem(ACCESSIBLE_MODE_KEY);
      return next;
    });
  }, []);

  return { accessibleMode, overlayAccessible, manualAccessibleMode, toggleManualAccessible };
}
